export default __webpack_public_path__ + "static/media/card-img-placeholder.360fba5e.png";